// Vuex Client module mutations
export const FILL_USER_SESSION = 'FILL_USER_SESSION';
export const FILL_ERROR_DATA = 'FILL_ERROR_DATA';
export const FILL_LOGIN_TOKEN = 'FILL_LOGIN_TOKEN';
